<script>
    export default {
        
    }
</script>

<template>
    <div class="card is-flex">
        <div class="card-image">
            <picture class="image is-4by3"><img width="400" height="300" alt="Placeholder image" /></picture>
        </div>
        <div class="card-content is-flex-grow-1 is-flex is-flex-direction-column">
            <div class="block"><div class="progress has-background-text is-large" value="0" max="100"></div></div>
            <div class="block"><div class="progress has-background-text" value="0" max="100"></div></div>
            <div class="tags">
                <div v-for="index in 3" :key="index" class="tag is-primary"><div class="progress is-small is-white" value="100" max="100"></div></div>
            </div>
            <div v-for="index in 3" :key="index" class="block"><div class="progress has-background-text" value="0" max="100"></div></div>
        </div>
    </div>
</template>
